import { Container, Divider } from '@chakra-ui/react';
import CustomStepper from 'components/ui/custom-stepper/CustomStepper';
import StepperProvider from 'components/ui/custom-stepper/CustomStepperContext';
import HeaderBarInternal from 'components/ui/HeaderBarInternal';
import { wrapperDialogDefaultProps } from 'features/emails/config';
import { useResource } from 'hooks/useResource';
import { useParams } from 'react-router-dom';
import ListNoteTopics from '../components/ListNoteTopics';
import AgendaProvider from '../contexts/AgendaContext';

export default function PageCreateNoteTopics() {
  const { id } = useParams() as { id: string };
  const { data: note } = useResource({ id, resourceName: 'note', path: 'notes' });

  return (
    <StepperProvider
      steps={['Dados da nota', 'Tópicos da nota']}
      activeStepIndex={1}
    >
      <AgendaProvider>
        <HeaderBarInternal
          title="Criar nota"
          backTo="/notas-de-agenda"
          dialogProps={wrapperDialogDefaultProps}
        >
          <CustomStepper />
        </HeaderBarInternal>
      
        <Divider />

        <Container 
          variant="internal"
          flexDirection="column"
        >
        { note && <ListNoteTopics note={note} /> }
        </Container>
      </AgendaProvider> 
    </StepperProvider>
  )
}